import PropTypes from "prop-types"
import styled from "styled-components"

import { stateIndicator } from "../../common/constants"

import { Box } from "@chakra-ui/react"
import { useBrandedTranslation } from "../../../../../common/hooks/useBrandedTranslation"
import NewIndicator from "../../../../shared/NewIndicator"
import PhasingOutIndicator from "../../../../shared/PhasingOutIndicator"
import { useOpenGallery } from "../../context/OpenGalleryContext"
import ArchivedIndicator from "../ArchivedIndicator"
import ArticleCode from "../ArticleCode"
import TableArticleImage from "./TableArticleImage"
import ThreeDotsMenu from "./ThreeDotsMenu/ThreeDotsMenu"

const Styles = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  align-items: flex-start;

  &.td--highlighted-from-search {
    position: relative;
    z-index: ${({ theme }) => theme.zIndex.pdpUnderArticleTableHeader};
    &:before {
      content: "";
      z-index: ${({ theme }) => theme.zIndex.searchHighlightedArticle};
      position: absolute;
      width: ${({ theme }) => theme.sizes.base}px;
      left: ${({ theme }) => `${-theme.sizes.gapLarge}px`};
      top: ${({ theme }) => `${-theme.sizes.gapSmall + 2}px`};
      bottom: ${({ theme }) => `${-theme.sizes.gapSmall + 2}px`};
      background: ${({ theme }) => theme.colors.warning};
    }
  }
`

const FlexDivColumn = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-left: ${({ theme }) => theme.sizes.gapLarge}px;
  padding-top: ${({ theme }) => theme.sizes.gapSmall}px;
`

const FlexDivRow = styled.div`
  display: flex;
  align-items: flex-start;
`

function ArticleCodeCell({
  text,
  image,
  state,
  options,
  availableZipOptionsFormData,
  isHighlightedFromSearch,
  rowNumberVal,
  resetScroll,
}) {
  const { t } = useBrandedTranslation()
  const openGallery = useOpenGallery()

  const isNew = state?.indicator === stateIndicator.NEW
  const isPhasedOut = state?.indicator === stateIndicator.PHASEOUT
  const isArchived = state?.archived

  const hasOrderRelated = state?.orderRelated && !isArchived

  const newTagTooltipLabel = state?.from ? `${t("pdp-newLabelTip")} ${state?.from}` : ""

  return (
    <Styles className={isHighlightedFromSearch && "td--highlighted-from-search"}>
      <TableArticleImage text={text} image={image} onClick={() => openGallery(text)} />
      <FlexDivColumn>
        <FlexDivRow>
          <ArticleCode articleCode={text} hasOrderRelated={hasOrderRelated} />
        </FlexDivRow>
        {isNew && <NewIndicator tooltipLabel={newTagTooltipLabel} tooltipPlacement="top" size="xs" />}
        {isPhasedOut && <PhasingOutIndicator />}
        {isArchived && <ArchivedIndicator />}
      </FlexDivColumn>
      {/* Placeholder div for the absolutely positioned three dot menu button */}
      <Box w="10" h="10" mr="2" mt="-0.5" display="hidden" flexShrink="1" />
      <ThreeDotsMenu
        options={options}
        articleCode={text}
        availableZipOptionsFormData={availableZipOptionsFormData}
        rowNumberVal={rowNumberVal}
        resetScroll={resetScroll}
        isArchived={isArchived}
      />
    </Styles>
  )
}

export default ArticleCodeCell

ArticleCodeCell.propTypes = {
  text: PropTypes.string,
  image: PropTypes.string,
  state: PropTypes.object,
  options: PropTypes.shape({
    zipCadDrawingsLink: PropTypes.string,
    zipPhotosDrawingsLink: PropTypes.string,
    tenderTextId: PropTypes.string,
  }),
  availableZipOptionsFormData: PropTypes.object,
  isHighlightedFromSearch: PropTypes.bool,
  rowNumberVal: PropTypes.number,
  resetScroll: PropTypes.func,
}
